import { Action } from '@ngrx/store';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import { IApiAutomationQueryParams } from '../shared/api-automation.model';
import { ActivityCRUDInterface } from '../../../../shared/component/filter/filter.class';
import { IApiAutomationOption } from '../shared/api-automation.model';
import {
  IChangeActivity,
  IChangeActivityRow,
} from '../../../../view/settings/api-automation-settings/change-activity/change-activity.model';
import { TaskFilterCRUDInterface } from '../../../../shared/component/filter/filter.class';

export enum ActionTypes {
  CHANGE_ACTIVITYS_DATA_LOADING = '[CHANGE_ACTIVITYS] CHANGE_ACTIVITYS DATA LOADING',
  CHANGE_ACTIVITYS_DATA_LOADED = '[CHANGE_ACTIVITYS] CHANGE_ACTIVITYS DATA LOADED',
  GET_CHANGE_ACTIVITY = '[CHANGE_ACTIVITYS] GET_CHANGE_ACTIVITY LOADING',
  GET_CHANGE_ACTIVITY_COMPLETED = '[CHANGE_ACTIVITYS] GET_CHANGE_ACTIVITY COMPLETED',
  ADD_CHANGE_ACTIVITY = '[CHANGE_ACTIVITYS] ADD_CHANGE_ACTIVITY',
  ADD_CHANGE_ACTIVITY_COMPLETED = '[CHANGE_ACTIVITYS] ADD_CHANGE_ACTIVITY COMPLETED',
  EDIT_CHANGE_ACTIVITY = '[CHANGE_ACTIVITYS] EDIT_CHANGE_ACTIVITY',
  EDIT_CHANGE_ACTIVITY_COMPLETED = '[CHANGE_ACTIVITYS] EDIT_CHANGE_ACTIVITY COMPLETED',
  DELETE_CHANGE_ACTIVITYS = '[CHANGE_ACTIVITYS] DELETE_CHANGE_ACTIVITYS',
  DELETE_CHANGE_ACTIVITYS_COMPLETED = '[CHANGE_ACTIVITYS] DELETE_CHANGE_ACTIVITYS COMPLETED',
  ACTIVITIES_DATA_LOADING = '[CHANGE_ACTIVITYS] ACTIVITIES DATA LOADING',
  ACTIVITIES_DATA_COMPLETED = '[CHANGE_ACTIVITYS] ACTIVITIES DATA COMPLETED',
  TASKS_DATA_LOADING = '[CHANGE_ACTIVITYS] TASKS DATA LOADING',
  TASKS_DATA_COMPLETED = '[CHANGE_ACTIVITYS] TASKS DATA COMPLETED',
  EXTENDED_TASKS_DATA_LOADING = '[CHANGE_ACTIVITYS] EXTENDED_TASKS DATA LOADING',
  EXTENDED_TASKS_DATA_COMPLETED = '[CHANGE_ACTIVITYS] EXTENDED_TASKS DATA COMPLETED',
  CLEANER_RULES_DATA_LOADING = '[CHANGE_ACTIVITYS] CLEANER_RULES DATA LOADING',
  CLEANER_RULES_DATA_COMPLETED = '[CHANGE_ACTIVITYS] CLEANER_RULES DATA COMPLETED',
  TASK_LOOKUP_DATA_LOADING = '[CHANGE_ACTIVITYS] TASK_LOOKUP DATA LOADING',
  TASK_LOOKUP_DATA_COMPLETED = '[CHANGE_ACTIVITYS] TASK_LOOKUP DATA COMPLETED',
  FETCH_ERROR = '[CHANGE_ACTIVITYS] FETCH ERROR',
}

export class ChangeActivitiesLoading implements Action {
  readonly type = ActionTypes.CHANGE_ACTIVITYS_DATA_LOADING;

  constructor(public params: IApiAutomationQueryParams) {}
}

export class ChangeActivitiesLoaded implements Action {
  readonly type = ActionTypes.CHANGE_ACTIVITYS_DATA_LOADED;

  constructor(public payload: GetManyResponseInterface<IChangeActivity>) {}
}

export class GetChangeActivity implements Action {
  readonly type = ActionTypes.GET_CHANGE_ACTIVITY;

  constructor(public recordId: number) {}
}

export class GetChangeActivityCompleted implements Action {
  readonly type = ActionTypes.GET_CHANGE_ACTIVITY_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IChangeActivity>) {}
}
export class AddChangeActivity implements Action {
  readonly type = ActionTypes.ADD_CHANGE_ACTIVITY;

  constructor(
    public record: IChangeActivityRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class AddChangeActivityCompleted implements Action {
  readonly type = ActionTypes.ADD_CHANGE_ACTIVITY_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IChangeActivity>) {}
}
export class EditChangeActivity implements Action {
  readonly type = ActionTypes.EDIT_CHANGE_ACTIVITY;

  constructor(
    public recordId: number,
    public record: IChangeActivityRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class EditChangeActivityCompleted implements Action {
  readonly type = ActionTypes.EDIT_CHANGE_ACTIVITY_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IChangeActivity>) {}
}
export class DeleteChangeActivities implements Action {
  readonly type = ActionTypes.DELETE_CHANGE_ACTIVITYS;

  constructor(public payload: number[]) {}
}

export class DeleteChangeActivitiesCompleted implements Action {
  readonly type = ActionTypes.DELETE_CHANGE_ACTIVITYS_COMPLETED;

  constructor(
    public isBulk: boolean,
    public response: BulkResponseDataInterface,
  ) {}
}
export class ActivitiesDataLoading implements Action {
  readonly type = ActionTypes.ACTIVITIES_DATA_LOADING;
}

export class ActivitiesDataCompleted implements Action {
  readonly type = ActionTypes.ACTIVITIES_DATA_COMPLETED;

  constructor(public payload: ActivityCRUDInterface[]) {}
}
export class TasksDataLoading implements Action {
  readonly type = ActionTypes.TASKS_DATA_LOADING;

  constructor(public activityId: number) {}
}

export class TasksDataCompleted implements Action {
  readonly type = ActionTypes.TASKS_DATA_COMPLETED;

  constructor(public payload: TaskFilterCRUDInterface[]) {}
}
export class ExtendedTasksDataLoading implements Action {
  readonly type = ActionTypes.EXTENDED_TASKS_DATA_LOADING;

  constructor(public activityId: number) {}
}

export class ExtendedTasksDataCompleted implements Action {
  readonly type = ActionTypes.EXTENDED_TASKS_DATA_COMPLETED;

  constructor(public payload: TaskFilterCRUDInterface[]) {}
}
export class CleanerRulesDataLoading implements Action {
  readonly type = ActionTypes.CLEANER_RULES_DATA_LOADING;

  constructor() {}
}

export class CleanerRulesDataCompleted implements Action {
  readonly type = ActionTypes.CLEANER_RULES_DATA_COMPLETED;

  constructor(public payload: IApiAutomationOption[]) {}
}
export class TaskLookupDataLoading implements Action {
  readonly type = ActionTypes.TASK_LOOKUP_DATA_LOADING;

  constructor(public taskIds: number[]) {}
}

export class TaskLookupDataCompleted implements Action {
  readonly type = ActionTypes.TASK_LOOKUP_DATA_COMPLETED;

  constructor(public payload: IApiAutomationOption[]) {}
}
export class FetchError implements Action {
  readonly type = ActionTypes.FETCH_ERROR;

  constructor(public errorAction: ActionTypes) {}
}

export type ChangeActivityActions =
  | ChangeActivitiesLoading
  | ChangeActivitiesLoaded
  | GetChangeActivity
  | GetChangeActivityCompleted
  | AddChangeActivity
  | AddChangeActivityCompleted
  | EditChangeActivity
  | EditChangeActivityCompleted
  | DeleteChangeActivities
  | DeleteChangeActivitiesCompleted
  | ActivitiesDataLoading
  | ActivitiesDataCompleted
  | TasksDataLoading
  | TasksDataCompleted
  | ExtendedTasksDataLoading
  | ExtendedTasksDataCompleted
  | CleanerRulesDataLoading
  | CleanerRulesDataCompleted
  | TaskLookupDataLoading
  | TaskLookupDataCompleted
  | FetchError;
